module.exports = __webpack_public_path__ + "static/img/1_1_2_1.4ac3a560.jpg";